import {
  FaReact,
  FaNodeJs,
  FaDatabase,
  FaDocker,
} from 'react-icons/fa';
import {
  SiJavascript,
  SiKubernetes,
  SiHelm,
  SiCplusplus,
} from 'react-icons/si';
import type { IconType } from 'react-icons';

type Skill = {
  name: string;
  icon: IconType;
};

const skills: Skill[] = [
  { name: 'JavaScript', icon: SiJavascript },
  { name: 'Kubernetes', icon: SiKubernetes },
  { name: 'Docker', icon: FaDocker },
  { name: 'C/C++', icon: SiCplusplus },
  { name: 'Helm', icon: SiHelm },
  { name: 'React', icon: FaReact },
  { name: 'Node.js', icon: FaNodeJs },
  { name: 'SQL', icon: FaDatabase },
];

function Skills() {
  return (
    <section id="skills-section" className="portfolio-section p-4 p-md-5" aria-labelledby="skills-title">
      <h2 id="skills-title" className="section-title h3 mb-3">
        Skillset
      </h2>
      <p className="section-text mb-4">
        These are technologies and topics I'm familiar with through both professional work and personal projects. 
        I've gained hands-on experience with these tools by building real-world applications, deploying containerized 
        services, and continuously exploring new ways to solve problems. While I'm always learning and expanding my 
        skillset, these represent the core areas where I feel confident contributing and creating meaningful solutions.
      </p>

      <div className="row g-3">
        {skills.map(({ name, icon: Icon }) => (
          <div className="col-12 col-sm-6 col-lg-3" key={name}>
            <article className="skill-card h-100 p-3 d-flex align-items-center gap-3">
              <span className="skill-icon" aria-hidden="true">
                {Icon({})}
              </span>
              <h3 className="h6 mb-0">{name}</h3>
            </article>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
